module.exports = __webpack_public_path__ + "static/shifter_adventurer-ced4164dbc81d4e345a71820409246ae.png";